import { combineReducers } from "redux";

import { changelogSlice } from "./changelog.slice";

export const changelogReducerMap = {
	changelog: changelogSlice.reducer,
};

const reducers = combineReducers(changelogReducerMap);

export type ChangelogState = ReturnType<typeof reducers>;
